import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'bmcore-beats-not-found',
  templateUrl: './bmcore-beats-not-found.component.html',
  styleUrls: ['./bmcore-beats-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreBeatsNotFoundComponent implements OnInit {
  @Input() title: string
  @Output() closePopupEvent = new EventEmitter()

  constructor() {}

  ngOnInit(): void {}

  clickHandler() {
    this.closePopupEvent.emit()
  }
}
